
    import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
    import api from '@/api'
    import {imageUrl} from '@/utils/common'

    @Component({
        name: "uploadNew",
        components: {}
    })

    export default class extends Vue {

        loading = false
        baseUrl = imageUrl
        dataAuth: any = {};

        handleAvatarSuccess(res: any, file: any) {
            if(res.data && res.errcode == 0) {
                this.$message.success('上传成功')
                let obj = {
                    name: file.name,
                    filecode: res.data
                }
                this.$emit('getData', obj)
            } else {
                this.$message.warning('上传失败，请重新上传')
            }

        }

        beforeAvatarUpload(file: any) {
            // console.log('file', file.type);
            // const isJPG = file.type === "application/pdf";
            // if (!isJPG) {
            //     this.$message.error("请上传pdf文件!");
            // }
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            let _that = this;
            this.loading = true
            return new Promise(function (resolve, reject) {
                // if (isJPG) {
                    api
                        .getPolicy({
                            file_name: file.name,
                        })
                        .then((data) => {
                            _that.dataAuth = data;
                            resolve(true);
                        })
                        .catch(() => {
                            reject(false);
                        }).finally(() => {
                        _that.loading = false
                    });
                // } else {
                //     _that.loading = false
                //     reject(false);
                // }

            });
        }

    }
